import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email: string, password: string) =>
  api.post('/auth/login', { email, password });

export const register = (data: any) =>
  api.post('/auth/register', data);

export const getMe = () =>
  api.get('/auth/me');

// Devices
export const getDevices = () =>
  api.get('/devices');

export const blockDevice = (id: string) =>
  api.post(`/devices/${id}/block`);

export const unblockDevice = (id: string) =>
  api.post(`/devices/${id}/unblock`);

export const shutdownDevice = (id: string) =>
  api.post(`/devices/${id}/shutdown`);

// Groups
export const getGroups = () =>
  api.get('/groups');

export const createGroup = (data: any) =>
  api.post('/groups', data);

export const deleteGroup = (id: string) =>
  api.delete(`/groups/${id}`);

export const blockGroup = (id: string) =>
  api.post(`/groups/${id}/block`);

// Users
export const getUsers = () =>
  api.get('/users');

export const inviteUser = (data: any) =>
  api.post('/users/invite', data);

export const deactivateUser = (id: string) =>
  api.post(`/users/${id}/deactivate`);

export const activateUser = (id: string) =>
  api.post(`/users/${id}/activate`);

export const changeUserRole = (id: string, role: string) =>
  api.post(`/users/${id}/role`, { role });

export default api;

// Device History
export const getDeviceHistory = (id: string) =>
  api.get(`/history/${id}`);

// Force ping device
export const pingDevice = (id: string) =>
  api.post(`/devices/${id}/ping`);
